// extracted by mini-css-extract-plugin
export default {"cta":"jF-z","disabled":"kF-z"};